module.exports = __webpack_public_path__ + "img/p3.0b963629.png";